"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChannelEventCallbacks = createChannelEventCallbacks;
function createChannelEventCallbacks(contextRef) {
    return {
        ai_channel_exit: function (channel) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_channel_exit', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { channel: channel }));
        },
        ai_channel_join: function (channel) {
            var ctx = contextRef.current;
            if (!ctx.posthogClient)
                return;
            ctx.posthogClient.capture('ai_channel_join', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { channel: channel }));
        },
    };
}
